/**
 * Bridge between the app's hex brand variables and twreact-ui 2.0 tokens.
 * twreact-ui 2.0 colours read `--dt-<palette>-<step>` as space-separated RGB
 * channels ("37 99 235") so Tailwind opacity modifiers (`bg-primary-900/40`) work.
 * These helpers turn a store theme palette into both forms (applyBrand's brandVars
 * does the same for single brand variables). Pure: no DOM access.
 */

import { hexToTriplet } from './applyTheme';

/** "#2563eb" | "#26e" → "37 99 235"; anything else → null. */
export const hexToChannels = (hex) => (typeof hex === 'string' ? hexToTriplet(hex) : null);

/** { 50: '#…', … } → { '<prefix>-50': '#…', … } (values unchanged). */
export function paletteVars(palette, prefix) {
  return Object.fromEntries(Object.entries(palette || {}).map(([step, value]) => [`${prefix}-${step}`, value]));
}

/** { 50: '#…', … } → { '--dt-<name>-50': 'r g b', … }, skipping values that are not hex. */
export function dtPaletteVars(palette, name) {
  return Object.fromEntries(
    Object.entries(palette || {})
      .map(([step, hex]) => [`--dt-${name}-${step}`, hexToChannels(hex)])
      .filter(([, channels]) => channels),
  );
}

/**
 * The CSS variables a store theme palette sets: the legacy `--color-primary-*` hex
 * scale, twreact-ui's `--dt-primary-*`, and the accent palette as `--dt-secondary-*`.
 */
export function themePaletteVars(palette = {}) {
  return {
    ...paletteVars(palette.primary, '--color-primary'),
    ...dtPaletteVars(palette.primary, 'primary'),
    ...dtPaletteVars(palette.accent, 'secondary'),
  };
}
